module.exports = __webpack_public_path__ + "static/media/Slider 1 5.f13d739a.jpg";